<template>
    <div>
        <Navbar/>
        <div class="p-4">
            <div class="d-flex mb-4 text-darker justify-content-evenly">
            <a href="#" class="text-secondary text-decoration-none">
                <i class="fas fa-search"></i> Szukaj
            </a>
            <a href="#" class="text-primary text-decoration-none">
                <i class="fas fa-sync"></i> Odśwież
            </a>
            </div>
            <hr>
            <div class="row">
            <div class="d-lg-flex my-2 justify-content-between">
                <div>
                    <h5>
                    <router-link :to="{ name: 'UserList' }" class="text-decoration-none fw-bold">
                        LISTA UŻYTKOWNIKÓW
                    </router-link>
                    <i class="fa-solid fa-circle-arrow-right mx-3"></i>
                    </h5>
                    <h5 class="fw-bold">
                        Dodaj odbiorcę powiadomień
                    </h5>
                </div>
                <div>
                    <router-link :to="{ name: 'MailingList' }" class="btn btn-primary">
                        Powrót do listy powiadomień
                    </router-link>
                </div>
            </div>
            </div>
        </div>
        <h2>
            Dodaj odbiorcę powiadomień
        </h2>

        <div>
            <form @submit.prevent="AddRecipient">
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    required
                    placeholder="Wpisz nazwę"
                    v-model="recipient.name"
                >
                <input
                    type="text"
                    class="form-control mt-4 w-50 mx-auto"
                    required
                    placeholder="Wpisz adres email"
                    v-model="recipient.value"
                >
                <button role="submit" class="btn btn-primary mt-5 w-50">
                    Dodaj
                </button>
            </form>
        </div>
    </div>
</template>

<script> 
import Navbar from '../../components/Navbar.vue'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
    components: {
        Navbar
    },
    data () {
        return {
            recipient: {
                value: '',
                name: '',
                type: ''
            }
        }
    }, mounted () {

    }, methods: {
        AddRecipient () {
            const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

            axios.post(process.env.VUE_APP_API_BASE_URL + 'NotificationRecipient', this.recipient, config)
                .then(response => {
                    Swal.fire('Sukces!', 'Pomyślnie dodano odbiorcę powiadomień', 'success')
                    this.$router.push({ name: 'MailingList' })    
                })
                .catch(error => {
                    Swal.fire('Błąd!', 'Ten adres e-mail jest już w bazie danych', 'info')
                })
        }
    }
}

</script>

<style scoped>
.btn {
    width: 150px;
}
</style>
